import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

import './index.less';

function BackButton({ onClick, ...props }) {
  return (
    <Button data-testid={props['data-testid']} className={cx('back-button', 'back-button__button')} onClick={onClick} block>
      <LeftOutlined className="back-button__arrow" />
      <span className="back-button__text">Back</span>
    </Button>
  );
}

BackButton.propTypes = {
  onClick: PropTypes.func,
  'data-testid': PropTypes.string,
};

export default BackButton;
